import { render, staticRenderFns } from "./DetailsGrouping.vue?vue&type=template&id=9c2af322&scoped=true&"
import script from "./DetailsGrouping.vue?vue&type=script&lang=js&"
export * from "./DetailsGrouping.vue?vue&type=script&lang=js&"
import style0 from "./DetailsGrouping.vue?vue&type=style&index=0&id=9c2af322&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2af322",
  null
  
)

export default component.exports